define('common/views/header_view_mdheader',['require','exports','module','base/view','lodash','jquery','backbone','i18n','env','services/auth','react','react-dom','mdheaderjs','./footer_view_mdfooter','common/views/sidebar_view_mdsidebar','../collections/globals','modules/includes_editor/index','./download_leads_popup','ThemesHelper','common/models/appstate'],function (require, exports, module) {
  'use strict';

  var View = require('base/view'),
    _ = require('lodash'),
    $ = require('jquery'),
    Backbone = require('backbone'),
    i18n = require('i18n'),
    Config = require('env'),
    Auth = require('services/auth'),
    authInfo = Auth.getAuthInfo(),
    React = require('react'),
    ReactDOM = require('react-dom'),
    MDHeader = require('mdheaderjs'),
    FooterViewMDFooter = require('./footer_view_mdfooter'),
    SidebarViewMDSidebar = require('common/views/sidebar_view_mdsidebar'),
    GlobalCollection = require('../collections/globals'),
    IncludeContentService = require('modules/includes_editor/index'),
    DownloadLeadsPopup = require('./download_leads_popup'),
    ThemesHelper = require('ThemesHelper'),
    AppState = require('common/models/appstate');

  var Header = Backbone.View.extend({
    noTemplate: true,

    initialize: function (isEditor) {
      this.isEditor = isEditor || false;

      if (this.model) {
        this.listenTo(this.model, 'sync', this.render);
      }
      if (AppState._companyInfo) {
        this.listenTo(AppState._companyInfo, 'all', this.render);
      }
    },

    showDownloadLeads: function () {
      DownloadLeadsPopup.show();
    },

    showGlobalsEditor: function (e) {
      var globals = new GlobalCollection(null, { companyId: authInfo.getCompanyId() });

      IncludeContentService.editGlobals(globals, function () {
        globals.save();
      });

      globals.fetch({
        error: function (collection, resp) {
          if (resp.status === 404) {
            collection.saveMethod = 'create';
          }
        },
      });
    },

    getCurrentLang: function () {
      return i18n.lng().substr(0, 2);
    },

    getCurrentComponentVersionAsGlobal: function (component) {
      window.MDHeader = {
        version: component.type.defaultProps.version || '0.0.0',
      };
    },

    render: function () {
      authInfo.isAdm();
      var self = this;
      var headerOptions = {
        theme: ThemesHelper.getCurrentTheme(),
        authInfo: authInfo,
        showCompanies: true,
        lang: this.getCurrentLang(),
        onChangeLanguage: function (lang) {
          i18n.setLng(lang, function () {
            $('html').i18n();
            self.render();
          });
          new FooterViewMDFooter({ el: '#md__footer' }).setUserLang(lang).refresh();
          new SidebarViewMDSidebar({ el: '#md__sidebar__wrapper' }).setUserLang(lang).render();
        },
        openSupportChat: null,
        logoutUrl: Config.logoutUrl,
        myAccountUrl: Config.signupUrl + (authInfo.isAdm() ? '/accounts' : '/accounts/user/me'),
        onChangeCompany: function (empId) {
          const regex = /\d/;
          if (regex.test(document.location.pathname)) {
            document.location = '/?company_id=' + empId;
          } else {
            document.location.search = '?company_id=' + empId;
          }
        },
        properties: { isAppSumo: AppState.isAppSumo(), isEmBlue: AppState.isEmBlue() },
        bookSessionUrl:
          'https://calendly.com/giulia-landis-embluemail/workshop-tu-nuevo-ecosistema-emblue-ai?utm_source=MDirector-Migración-Help&utm_medium=calendario&utm_campaign=migracion_mdirector&utm_content=help-agendar-cita',
      };

      var HeaderComponent = React.createElement(MDHeader, headerOptions);

      ReactDOM.render(HeaderComponent, this.el);

      this.getCurrentComponentVersionAsGlobal(HeaderComponent);
      return this;
    },
  });

  module.exports = Header;
});

